import React from "react";
import FormulDevelopServicesRedesign from "../redesign/FormulDevelopServicesRedesign";

const FormulDevelopServices = () => {
  return <FormulDevelopServicesRedesign />;
};

export default FormulDevelopServices;
